module.exports = __webpack_public_path__ + "img/Frame-55.2a378f38.svg";